(function (global) {
  function formatMoney(cents, currency) {
    var amount = Number(cents || 0) / 100;
    try {
      return new Intl.NumberFormat("es-CO", {
        style: "currency",
        currency: currency || "COP",
        maximumFractionDigits: 0
      }).format(amount);
    } catch (error) {
      return "$" + Math.round(amount).toLocaleString("es-CO");
    }
  }

  function splitName(fullName) {
    var parts = String(fullName || "")
      .trim()
      .split(/\s+/)
      .filter(Boolean);
    if (!parts.length) {
      return { firstName: "", lastName: "" };
    }
    if (parts.length === 1) {
      return { firstName: parts[0], lastName: "-" };
    }
    return {
      firstName: parts[0],
      lastName: parts.slice(1).join(" ")
    };
  }

  function findVariantDetails(products, variantId) {
    var id = String(variantId);
    for (var i = 0; i < products.length; i += 1) {
      var product = products[i];
      var variants = product.variants || [];
      for (var j = 0; j < variants.length; j += 1) {
        if (String(variants[j].id) === id) {
          return {
            product: product,
            variant: variants[j]
          };
        }
      }
      if (String(product.default_variant_id) === id) {
        return {
          product: product,
          variant: {
            id: product.default_variant_id,
            title: "Default",
            price: product.price || 0,
            image: product.img || ""
          }
        };
      }
    }
    return null;
  }

  function cartAddUrl(cartUrl) {
    var base = String(cartUrl || "/cart/add").replace(/\.js$/, "");
    return base + ".js";
  }

  var CO_PROVINCE_CODES = {
    Amazonas: "AMA",
    Antioquia: "ANT",
    Arauca: "ARA",
    Atlantico: "ATL",
    "Bogota D.C.": "DC",
    Bolivar: "BOL",
    Boyaca: "BOY",
    Caldas: "CAL",
    Caqueta: "CAQ",
    Casanare: "CAS",
    Cauca: "CAU",
    Cesar: "CES",
    Choco: "CHO",
    Cordoba: "COR",
    Cundinamarca: "CUN",
    Guainia: "GUA",
    Guaviare: "GUV",
    Huila: "HUI",
    "La Guajira": "LAG",
    Magdalena: "MAG",
    Meta: "MET",
    Narino: "NAR",
    "Norte de Santander": "NSA",
    Putumayo: "PUT",
    Quindio: "QUI",
    Risaralda: "RIS",
    "San Andres": "SAP",
    Santander: "SAN",
    Sucre: "SUC",
    Tolima: "TOL",
    "Valle del Cauca": "VAC",
    Vaupes: "VAU",
    Vichada: "VID"
  };

  function variantGid(variantId) {
    return "gid://shopify/ProductVariant/" + variantId;
  }

  function normalizePhone(phone) {
    var digits = String(phone || "").replace(/\D/g, "");
    if (!digits) {
      return "";
    }
    if (digits.indexOf("57") === 0 && digits.length >= 12) {
      return "+" + digits;
    }
    if (digits.length === 10) {
      return "+57" + digits;
    }
    return "+" + digits;
  }

  function checkoutEmail(customer) {
    if (customer.email) {
      return customer.email;
    }
    var digits = String(customer.phone || "").replace(/\D/g, "");
    if (digits) {
      return "cliente+" + digits + "@checkout.caletzza.local";
    }
    return "cliente@checkout.caletzza.local";
  }

  function buildCheckoutAddressPayload(customer) {
    var provinceCode = CO_PROVINCE_CODES[customer.province] || "CUN";
    var phone = normalizePhone(customer.phone);
    var address2 = customer.note ? String(customer.note).trim() : "";

    return {
      phone: phone,
      deliveryAddress: {
        firstName: customer.names.firstName,
        lastName: customer.names.lastName,
        address1: customer.address1,
        address2: address2,
        city: customer.city,
        provinceCode: provinceCode,
        countryCode: "CO",
        zip: "000000",
        phone: phone
      },
      mailingAddress: {
        firstName: customer.names.firstName,
        lastName: customer.names.lastName,
        address1: customer.address1,
        address2: address2,
        city: customer.city,
        province: customer.province,
        country: "Colombia",
        zip: "000000",
        phone: phone
      },
      selectableAddress: {
        selected: true,
        oneTimeUse: true,
        address: {
          deliveryAddress: {
            firstName: customer.names.firstName,
            lastName: customer.names.lastName,
            address1: customer.address1,
            address2: address2,
            city: customer.city,
            provinceCode: provinceCode,
            countryCode: "CO",
            zip: "000000",
            phone: phone
          }
        }
      }
    };
  }

  function PackCodCheckout(section, config) {
    this.section = section;
    this.config = config || {};
    this.root = section.querySelector("[data-pack-cod]");
    this.dialog = section.querySelector("[data-cod-dialog]");
    this.mainPanel = section.querySelector("[data-cod-main]");
    this.form = section.querySelector("[data-cod-form]");
    this.successPanel = section.querySelector("[data-cod-success]");
    this.errorNode = section.querySelector("[data-cod-error]");
    this.itemsNode = section.querySelector("[data-cod-items]");
    this.itemsWrap = section.querySelector("[data-cod-items-wrap]");
    this.itemsFade = section.querySelector("[data-cod-items-fade]");
    this.itemsHint = section.querySelector("[data-cod-items-hint]");
    this.subtotalNode = section.querySelector("[data-cod-subtotal]");
    this.discountNode = section.querySelector("[data-cod-discount]");
    this.discountRow = section.querySelector("[data-cod-discount-row]");
    this.taxNode = section.querySelector("[data-cod-tax]");
    this.taxRow = section.querySelector("[data-cod-tax-row]");
    this.shippingNode = section.querySelector("[data-cod-shipping]");
    this.totalNode = section.querySelector("[data-cod-total]");
    this.submitButton = section.querySelector("[data-cod-submit]");
    this.fallbackButton = section.querySelector("[data-cod-fallback]");
    this.orderNameNode = section.querySelector("[data-cod-order-name]");
    this.paymentNoteNode = section.querySelector("[data-cod-payment-note]");
    this.paymentsFieldset = section.querySelector("[data-cod-payments]");
    this.fieldsNode = section.querySelector("[data-cod-fields]");
    this.mpBrickWrap = section.querySelector("[data-cod-mp-brick]");
    this.mpBrickMount = section.querySelector("[data-cod-mp-brick-mount]");
    this.mpBackButton = section.querySelector("[data-cod-mp-back]");
    this.grid = section.querySelector(".pack-cod__grid");
    this.pendingItems = [];
    this.pendingLineItems = [];
    this.pendingSummary = null;
    this.pendingCustomer = null;
    this.mpBrickController = null;
    this.mpWalletCopyObserver = null;
    this.mpExternalReference = "";
    this.onComplete = null;
    this.isLoading = false;
    this.applyMetaPurchasePolicy();
    this.bindEvents();
    this.maybeConfirmEpaycoReturn();
    this.maybeConfirmMercadoPagoReturn();
  }

  /**
   * Bloquear Purchase Meta en landings RM / pack pay-x-get-y.
   * theme.liquid ya marca __czBlockMetaPurchase en handles landing-rm|remarketing.
   * BOPO / landing hombres NO se bloquea.
   */
  PackCodCheckout.prototype.applyMetaPurchasePolicy = function () {
    var mode =
      String(this.config.packMode || "").trim() ||
      (this.section && this.section.getAttribute("data-pack-mode")) ||
      "";
    var blockFromPack =
      this.config.blockMetaPurchase === true || mode === "pay-x-get-y";
    var blockFromPage = false;
    try {
      blockFromPage = global.__czBlockMetaPurchase === true;
    } catch (error) {
      blockFromPage = false;
    }
    this.blockMetaPurchase = blockFromPack || blockFromPage;
    try {
      if (blockFromPack) {
        global.__czBlockMetaPurchase = true;
      }
    } catch (error) {
      /* ignore */
    }
  };

  PackCodCheckout.prototype.shouldBlockMetaPurchase = function () {
    if (this.blockMetaPurchase) {
      return true;
    }
    try {
      if (global.__czBlockMetaPurchase === true) {
        return true;
      }
    } catch (error) {
      /* ignore */
    }
    return false;
  };

  PackCodCheckout.prototype.bindEvents = function () {
    var self = this;

    if (!this.root) {
      return;
    }

    this.root.addEventListener("click", function (event) {
      var isSuccess = self.successPanel && !self.successPanel.hidden;
      // En gracias: no cerrar al tocar el fondo oscuro (confundía con "falló la compra").
      if (event.target === self.root) {
        if (isSuccess) {
          return;
        }
        self.close();
        return;
      }
      if (event.target.closest("[data-cod-close]")) {
        self.close();
        if (isSuccess && typeof self.onComplete === "function") {
          self.onComplete();
        }
      }
    });

    if (this.form) {
      this.form.addEventListener("submit", function (event) {
        event.preventDefault();
        self.submit();
      });

      this.form.addEventListener("change", function (event) {
        if (event.target && event.target.name === "payment_method") {
          self.updatePaymentUI();
          self.refreshSummary();
        }
      });
    }

    if (this.paymentsFieldset) {
      this.paymentsFieldset.addEventListener("click", function (event) {
        var option = event.target.closest(".pack-cod__pay-card");
        if (!option) {
          return;
        }
        var options = self.paymentsFieldset.querySelectorAll(".pack-cod__pay-card");
        options.forEach(function (node) {
          node.classList.toggle("pack-cod__pay-card--active", node === option);
        });
      });
    }

    var doneButton = this.section.querySelector("[data-cod-done]");
    if (doneButton) {
      doneButton.addEventListener("click", function () {
        self.close();
        if (typeof self.onComplete === "function") {
          self.onComplete();
        }
      });
    }

    if (this.fallbackButton) {
      this.fallbackButton.addEventListener("click", function () {
        self.fallbackToCheckout();
      });
    }

    if (this.mpBackButton) {
      this.mpBackButton.addEventListener("click", function () {
        self.hideMercadoPagoBrick();
      });
    }

    if (this.itemsNode) {
      this.itemsNode.addEventListener("scroll", function () {
        self.updateItemsScrollState();
      });
    }
  };

  PackCodCheckout.prototype.getPaymentMode = function () {
    var mode = String(this.config.paymentMode || "").trim();
    if (mode) {
      return mode;
    }
    if (this.root && this.root.getAttribute("data-payment-mode")) {
      return this.root.getAttribute("data-payment-mode");
    }
    return this.config.enableOnlinePayment ? "online_invoice" : "cod";
  };

  PackCodCheckout.prototype.updateItemsScrollState = function () {
    if (!this.itemsNode || !this.itemsWrap) {
      return;
    }

    var list = this.itemsNode;
    var canScroll = list.scrollHeight > list.clientHeight + 2;
    var atBottom = list.scrollTop + list.clientHeight >= list.scrollHeight - 2;

    this.itemsWrap.classList.toggle("pack-cod__items-wrap--scrollable", canScroll);
    this.itemsWrap.classList.toggle("pack-cod__items-wrap--at-bottom", !canScroll || atBottom);

    if (this.itemsHint) {
      this.itemsHint.hidden = !canScroll || atBottom;
    }
  };

  PackCodCheckout.prototype.getTaxRate = function () {
    return Number(this.config.taxRatePercent || 19) / 100;
  };

  PackCodCheckout.prototype.getPaymentMethod = function () {
    if (!this.form) {
      return "cod";
    }
    var fixed = this.form.querySelector("[data-cod-payment-fixed]");
    if (fixed && fixed.value) {
      return fixed.value;
    }
    var selected = this.form.querySelector('input[name="payment_method"]:checked');
    if (selected && selected.value) {
      return selected.value;
    }
    var mode = this.getPaymentMode();
    if (mode === "mercadopago") {
      return "mercadopago";
    }
    if (mode === "online_invoice" && this.config.enableOnlinePayment) {
      return "cod";
    }
    return "cod";
  };

  PackCodCheckout.prototype.updatePaymentUI = function () {
    if (!this.submitButton) {
      return;
    }

    var method = this.getPaymentMethod();
    var isOnline = method === "online";
    var isMp = method === "mercadopago";

    if (this.isLoading) {
      this.submitButton.textContent = isOnline
        ? this.config.onlineLoadingLabel || "Redirigiendo al checkout..."
        : isMp
          ? this.config.mpLoadingLabel || "Preparando pago..."
          : this.config.loadingLabel || "Procesando...";
    } else {
      this.submitButton.textContent = isOnline
        ? this.config.onlineSubmitLabel || "Continuar al pago seguro"
        : isMp
          ? this.config.mpSubmitLabel || "Continuar al pago con ePayco"
          : this.config.submitLabel || "Confirmar pedido";
    }

    if (this.paymentNoteNode) {
      this.paymentNoteNode.textContent = isOnline
        ? this.config.paymentNoteOnline || "Checkout seguro de Shopify con tus metodos activos."
        : isMp
          ? this.config.paymentNoteMp ||
            "Con una sola cuenta, puedes pagar con dinero disponible, guardar tus tarjetas favoritas y más."
          : this.config.paymentNoteCod || "Pagas al recibir tu pedido.";
      this.paymentNoteNode.classList.toggle("pack-cod__payment-note--online", isOnline || isMp);
    }

    if (this.submitButton) {
      this.submitButton.classList.toggle("pack-cod__submit--online", isOnline || isMp);
      this.submitButton.hidden = Boolean(this.mpBrickWrap && !this.mpBrickWrap.hidden);
    }
  };

  PackCodCheckout.prototype.readDiscountRules = function () {
    if (global.PackDiscountRules && typeof global.PackDiscountRules.getRules === "function") {
      var rules = global.PackDiscountRules.getRules();
      if (rules && rules.length) {
        return rules;
      }
    }

    var node = document.querySelector("[data-discount-rules], [data-pack-discount-rules]");
    if (!node) {
      return [];
    }

    try {
      var parsed = JSON.parse(node.textContent || "[]");
      return Array.isArray(parsed) ? parsed : [];
    } catch (error) {
      return [];
    }
  };

  PackCodCheckout.prototype.applyPricingRules = function (lineItems) {
    if (!global.PackDiscountRules || typeof global.PackDiscountRules.applyRules !== "function") {
      var fallbackSubtotal = lineItems.reduce(function (sum, item) {
        return sum + Number(item.price || 0);
      }, 0);

      return {
        lineItems: lineItems,
        originalSubtotal: fallbackSubtotal,
        subtotal: fallbackSubtotal,
        discountTotal: 0,
        appliedRule: null,
        appliedTier: null
      };
    }

    return global.PackDiscountRules.applyRules(lineItems, {
      collectionHandle: this.config.collectionHandle || "",
      // Mismo precio de pack para COD y Mercado Pago.
      paymentMethod: this.config.pricingPaymentMethod || this.getPaymentMethod()
    });
  };

  PackCodCheckout.prototype.refreshSummary = function () {
    if (!this.pendingLineItems.length) {
      return;
    }

    var baseItems = this.pendingLineItems.map(function (item) {
      return {
        variantId: item.variantId,
        quantity: item.quantity,
        title: item.title,
        variantTitle: item.variantTitle,
        image: item.image,
        unitPrice: item.originalUnitPrice || item.unitPrice,
        price: (item.originalUnitPrice || item.unitPrice) * item.quantity
      };
    });
    var priced = this.applyPricingRules(baseItems);
    this.renderSummary(priced.lineItems, priced);
  };

  PackCodCheckout.prototype.renderSummary = function (lineItems, pricing) {
    var self = this;
    var subtotal = pricing && typeof pricing.subtotal === "number" ? pricing.subtotal : 0;
    var discountTotal = pricing && typeof pricing.discountTotal === "number" ? pricing.discountTotal : 0;
    var originalSubtotal =
      pricing && typeof pricing.originalSubtotal === "number" ? pricing.originalSubtotal : subtotal;
    var shipping = Number(this.config.shippingFlat || 0);
    // Landings: no sumar IVA (precio de regla ya es el cobrado al cliente).
    var taxRate = this.config.disableTax ? 0 : this.getTaxRate();
    var hideItemPrices = this.config.hideItemPrices !== false;
    // Mostrar subtotal ya con descuento por cantidad (ej. 4 × $23.475).
    var showNetSubtotal = this.config.showNetSubtotal !== false;
    // Flete incluido en el total pero oculto en UI ("Te obsequiamos el envío").
    var concealShippingFee = this.config.concealShippingFee !== false;

    if (!pricing) {
      subtotal = 0;
      lineItems.forEach(function (item) {
        subtotal += Number(item.price || 0);
      });
      originalSubtotal = subtotal;
    }

    this.itemsNode.innerHTML = lineItems
      .map(function (item) {
        var image = item.image
          ? '<img src="' + item.image + '" alt="">'
          : '<div class="pack-cod__item-placeholder"></div>';
        var priceCell = hideItemPrices
          ? ""
          : '<span class="pack-cod__item-price">' +
            formatMoney(item.price, self.config.currency) +
            "</span>";

        return (
          '<li class="pack-cod__item">' +
          image +
          '<div><p class="pack-cod__item-title">' +
          item.title +
          '</p><p class="pack-cod__item-variant">' +
          (item.variantTitle || "") +
          (item.tierLabel ? " · " + item.tierLabel : "") +
          "</p></div>" +
          priceCell +
          "</li>"
        );
      })
      .join("");

    if (
      !concealShippingFee &&
      subtotal >= Number(this.config.freeShippingThreshold || 0) &&
      this.config.freeShippingThreshold
    ) {
      shipping = 0;
    }

    var taxAmount = Math.round(subtotal * taxRate);
    var displayTotal = subtotal + shipping + taxAmount;
    var displaySubtotal = showNetSubtotal ? subtotal : discountTotal > 0 ? originalSubtotal : subtotal;

    this.pendingSummary = {
      subtotal: subtotal,
      originalSubtotal: originalSubtotal,
      discountTotal: discountTotal,
      taxAmount: taxAmount,
      taxRate: taxRate,
      shipping: shipping,
      total: displayTotal,
      appliedRule: pricing ? pricing.appliedRule : null,
      appliedTier: pricing ? pricing.appliedTier : null
    };

    if (this.discountRow) {
      // Con subtotal neto no hace falta la fila de descuento (evita mostrar $140.000).
      this.discountRow.hidden = showNetSubtotal || !(discountTotal > 0);
    }
    if (this.discountNode) {
      this.discountNode.textContent =
        discountTotal > 0
          ? "-" + formatMoney(discountTotal, this.config.currency)
          : formatMoney(0, this.config.currency);
    }
    if (this.subtotalNode) {
      this.subtotalNode.textContent = formatMoney(displaySubtotal, this.config.currency);
    }
    if (this.taxNode) {
      this.taxNode.textContent = formatMoney(taxAmount, this.config.currency);
    }
    if (this.taxRow) {
      this.taxRow.hidden = true;
    }
    if (this.shippingNode) {
      var showAsGift = concealShippingFee || shipping <= 0;
      this.shippingNode.textContent = showAsGift
        ? "Te obsequiamos el envío"
        : formatMoney(shipping, this.config.currency);
      this.shippingNode.classList.toggle("pack-cod__shipping-gift", showAsGift);
    }
    this.totalNode.textContent = formatMoney(displayTotal, this.config.currency);
    this.updateItemsScrollState();
  };

  PackCodCheckout.prototype.buildLineItems = function (cartItems, products) {
    var self = this;
    return cartItems
      .map(function (item) {
        var details = findVariantDetails(products, item.id);
        if (!details) {
          return null;
        }
        return {
          variantId: item.id,
          productId: details.product.id,
          productHandle: details.product.handle || "",
          title: details.product.name,
          quantity: item.quantity || 1,
          variantTitle: details.variant.title,
          image: details.variant.image || details.product.img || "",
          unitPrice: Number(details.variant.price || 0),
          originalUnitPrice: Number(details.variant.price || 0),
          price: Number(details.variant.price || 0) * (item.quantity || 1)
        };
      })
      .filter(Boolean);
  };

  PackCodCheckout.prototype.open = function (cartItems, products, options) {
    if (!this.root || !this.form) {
      return;
    }

    this.onComplete = options && options.onComplete;
    this.pendingItems = cartItems.slice();
    var lineItems = this.buildLineItems(cartItems, products);

    if (!lineItems.length) {
      return;
    }

    this.pendingLineItems = lineItems.map(function (item) {
      return Object.assign({}, item);
    });
    var priced = this.applyPricingRules(this.pendingLineItems);
    this.renderSummary(priced.lineItems, priced);
    this.form.hidden = false;
    this.form.reset();
    this.grid.hidden = false;
    this.hideError();

    if (this.paymentsFieldset) {
      var codRadio = this.form.querySelector('input[name="payment_method"][value="cod"]');
      if (codRadio) {
        codRadio.checked = true;
      }
      var paymentOptions = this.paymentsFieldset.querySelectorAll(".pack-cod__pay-card");
      paymentOptions.forEach(function (node, index) {
        node.classList.toggle("pack-cod__pay-card--active", index === 0);
      });
    }

    this.hideMercadoPagoBrick();
    this.updatePaymentUI();

    if (this.mainPanel) {
      this.mainPanel.hidden = false;
    }
    if (this.dialog) {
      this.dialog.classList.remove("pack-cod__dialog--success");
      this.dialog.style.minHeight = "";
    }
    if (this.successPanel) {
      this.successPanel.hidden = true;
      this.successPanel.style.position = "";
      this.successPanel.style.minHeight = "";
    }

    if (this.fallbackButton) {
      this.fallbackButton.hidden = true;
    }
    this.root.hidden = false;
    document.body.classList.add("pack-modal-open");

    // Landing: Meta InitiateCheckout al abrir el express (no depende de CAPI).
    this.trackMetaExpressEvent("InitiateCheckout");

    var self = this;
    window.requestAnimationFrame(function () {
      self.updateItemsScrollState();
    });
  };

  PackCodCheckout.prototype.close = function () {
    if (!this.root) {
      return;
    }
    this.hideMercadoPagoBrick();
    this.root.hidden = true;
    document.body.classList.remove("pack-modal-open");
  };

  PackCodCheckout.prototype.showError = function (message) {
    if (!this.errorNode) {
      return;
    }
    this.errorNode.hidden = !message;
    this.errorNode.textContent = message || "";
    // Sin fallback a checkout Shopify en el express.
    if (this.fallbackButton) {
      this.fallbackButton.hidden = true;
    }
  };

  PackCodCheckout.prototype.hideError = function () {
    this.showError("");
  };

  PackCodCheckout.prototype.setLoading = function (isLoading) {
    this.isLoading = isLoading;
    if (!this.submitButton) {
      return;
    }
    this.submitButton.disabled = isLoading;
    this.updatePaymentUI();
  };

  PackCodCheckout.prototype.readFormData = function () {
    var formData = new FormData(this.form);
    var fullName = String(formData.get("full_name") || "").trim();
    var names = splitName(fullName);
    return {
      formData: formData,
      fullName: fullName,
      names: names,
      phone: String(formData.get("phone") || "").trim(),
      email: String(formData.get("email") || "").trim(),
      city: String(formData.get("city") || "").trim(),
      province: String(formData.get("province") || "").trim(),
      address1: String(formData.get("address1") || "").trim(),
      note: String(formData.get("note") || "").trim()
    };
  };

  PackCodCheckout.prototype.buildCartAttributes = function (customer) {
    var attributes = {
      "Nombre completo": customer.fullName,
      Telefono: customer.phone,
      Ciudad: customer.city,
      Departamento: customer.province,
      Direccion: customer.address1,
      "Codigo postal": "000000",
      "Pack express": this.config.packLabel || "Pack Bodys",
      "Metodo de pago": "En linea (Shopify Checkout)"
    };

    if (customer.email) {
      attributes.Email = customer.email;
    }
    if (customer.note) {
      attributes["Barrio / Referencia"] = customer.note;
    }

    return attributes;
  };

  PackCodCheckout.prototype.buildCartNote = function (customer) {
    var lines = [
      (this.config.packLabel || "Pack Bodys") + " — pago en linea",
      "Nombre: " + customer.fullName,
      "Telefono: " + customer.phone
    ];

    if (customer.email) {
      lines.push("Email: " + customer.email);
    }

    lines.push(
      "Ciudad: " + customer.city,
      "Departamento: " + customer.province,
      "Direccion: " + customer.address1,
      "Codigo postal: 000000"
    );

    if (customer.note) {
      lines.push("Referencia: " + customer.note);
    }

    return lines.join("\n");
  };

  PackCodCheckout.prototype.fallbackToCheckout = function () {
    var self = this;
    if (!this.pendingItems.length) {
      return;
    }

    this.setLoading(true);
    fetch(cartAddUrl(this.config.cartUrl), {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json"
      },
      body: JSON.stringify({ items: this.pendingItems })
    })
      .then(function (response) {
        if (!response.ok) {
          throw new Error("No se pudo preparar el carrito.");
        }
        window.location.href = self.config.checkoutUrl || "/checkout";
      })
      .catch(function (error) {
        self.showError(error.message);
      })
      .finally(function () {
        self.setLoading(false);
      });
  };

  function parseOrderResponse(response) {
    return response.text().then(function (text) {
      var data = null;
      if (text) {
        try {
          data = JSON.parse(text);
        } catch (error) {
          throw new Error(
            "El servidor no respondio JSON (HTTP " +
              response.status +
              "). Revisa app proxy en Dev Dashboard."
          );
        }
      }

      if (!response.ok) {
        throw new Error((data && data.error) || "No se pudo crear el pedido (HTTP " + response.status + ").");
      }

      return data;
    });
  }

  function uniqueUrls(urls) {
    var seen = {};
    return (urls || []).filter(function (url) {
      if (!url || seen[url]) return false;
      seen[url] = true;
      return true;
    });
  }

  function postOrderWithFallback(urls, payload) {
    var list = uniqueUrls(urls);
    var lastError = new Error("No se pudo crear el pedido.");

    function attempt(index) {
      if (index >= list.length) {
        return Promise.reject(lastError);
      }
      return fetch(list[index], {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json"
        },
        body: JSON.stringify(payload)
      })
        .then(parseOrderResponse)
        .catch(function (error) {
          lastError = error;
          return attempt(index + 1);
        });
    }

    return attempt(0);
  }

  PackCodCheckout.prototype.storefrontGraphql = function (query, variables) {
    var self = this;
    if (!this.config.storefrontToken) {
      return Promise.reject(new Error("Falta el token Storefront API en la configuracion del theme."));
    }

    return fetch(this.config.storefrontApiUrl || "/api/2025-01/graphql.json", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-Shopify-Storefront-Access-Token": this.config.storefrontToken
      },
      body: JSON.stringify({ query: query, variables: variables })
    }).then(function (response) {
      return response.json();
    }).then(function (payload) {
      if (payload.errors && payload.errors.length) {
        throw new Error(payload.errors[0].message);
      }
      return payload.data;
    });
  };

  PackCodCheckout.prototype.showSuccess = function (orderName, options) {
    this.hideMercadoPagoBrick({ keepFormHidden: true });
    this.setLoading(false);
    this.hideError();

    if (this.form) {
      this.form.hidden = true;
    }
    if (this.grid) {
      this.grid.hidden = true;
    }
    if (this.mainPanel) {
      this.mainPanel.hidden = true;
    }
    if (this.dialog) {
      this.dialog.classList.add("pack-cod__dialog--success");
      // Defensa si CSS viejo deja min-height:0 con success absolute.
      this.dialog.style.minHeight = "min(420px, 72vh)";
    }
    if (this.root) {
      this.root.hidden = false;
      document.body.classList.add("pack-modal-open");
    }
    if (this.successPanel) {
      this.successPanel.hidden = false;
      this.successPanel.style.position = "relative";
      this.successPanel.style.minHeight = "min(420px, 72vh)";
    }
    if (this.orderNameNode && orderName) {
      this.orderNameNode.textContent = "Pedido " + orderName;
    }
    if (options && options.message) {
      var successText =
        this.successPanel &&
        (this.successPanel.querySelector("[data-cod-success-text]") ||
          this.successPanel.querySelector("[data-cod-success-message]"));
      if (successText) {
        successText.textContent = options.message;
      }
    }

    var self = this;
    window.requestAnimationFrame(function () {
      if (self.dialog && typeof self.dialog.scrollIntoView === "function") {
        self.dialog.scrollIntoView({ block: "center", behavior: "smooth" });
      }
      var doneButton = self.section.querySelector("[data-cod-done]");
      if (doneButton && typeof doneButton.focus === "function") {
        try {
          doneButton.focus();
        } catch (error) {
          /* ignore */
        }
      }
    });

    // Express: Meta Purchase lo cuenta el canal Shopify/CAPI al crear el pedido.
    // Aquí solo custom event + TikTok (sin fbq Purchase → evita 2× en Ads).
    this.trackPurchaseConversion(orderName, options && options.paymentMethod, options && options.orderId);
  };

  /**
   * Conversiones express (COD / ePayco / MP).
   * Meta Purchase: NO fbq — solo canal Meta/CAPI de Shopify (pedido Admin).
   * Sí: InitiateCheckout / AddPaymentInfo vía trackMetaExpressEvent (browser).
   * Sí: cod_express_purchase (custom) + TikTok CompletePayment.
   */
  PackCodCheckout.prototype.trackPurchaseConversion = function (
    orderName,
    paymentMethod,
    shopifyOrderId
  ) {
    var orderNameStr = String(orderName || "").trim();
    var legacyId = normalizeShopifyOrderId(shopifyOrderId);
    var dedupeKey = legacyId || orderNameStr;
    if (!dedupeKey) {
      return;
    }

    global.__czPackPurchases = global.__czPackPurchases || {};
    if (global.__czPackPurchases[dedupeKey]) {
      return;
    }
    global.__czPackPurchases[dedupeKey] = true;

    var storageKey = "cz_pack_purchase_" + dedupeKey;
    try {
      if (global.sessionStorage && global.sessionStorage.getItem(storageKey)) {
        return;
      }
      if (global.sessionStorage) {
        global.sessionStorage.setItem(storageKey, "1");
      }
    } catch (error) {
      // sessionStorage puede fallar en modo privado; seguimos con el disparo.
    }

    var payload = this.buildMetaExpressPayload(paymentMethod, orderNameStr, legacyId);

    // Solo evento custom (NO "purchase" ni fbq Purchase: GTM/theme + CAPI inflaban Ads).
    try {
      if (global.Shopify && global.Shopify.analytics && typeof global.Shopify.analytics.publish === "function") {
        global.Shopify.analytics.publish("cod_express_purchase", payload);
      }
    } catch (error) {
      console.warn("Shopify.analytics purchase publish failed:", error);
    }

    var pixels = detectInstalledAdPixels();
    fireTikTokPurchase(pixels.tiktokPixelId, payload);
  };

  PackCodCheckout.prototype.isMetaLandingContext = function () {
    try {
      if (global.__czAllowMetaPurchase === true) {
        return true;
      }
      if (document.documentElement && document.documentElement.dataset.czLanding === "true") {
        return true;
      }
      if (global.sessionStorage && global.sessionStorage.getItem("cz_landing_draft_checkout") === "1") {
        return true;
      }
    } catch (error) {
      /* ignore */
    }
    return false;
  };

  PackCodCheckout.prototype.buildMetaExpressPayload = function (
    paymentMethod,
    orderName,
    shopifyOrderId
  ) {
    var currency = String(this.config.currency || "COP").toUpperCase();
    var totalCents = this.pendingSummary ? Number(this.pendingSummary.total || 0) : 0;
    var value = Math.round(totalCents) / 100;
    var method = paymentMethod || this.getPaymentMethod() || "cod";
    var contents = (this.pendingLineItems || []).map(function (item) {
      var unit = Number(item.unitPrice || item.originalUnitPrice || 0) / 100;
      return {
        id: String(item.variantId || item.productId || ""),
        quantity: Number(item.quantity || 1),
        item_price: unit,
        content_id: String(item.variantId || item.productId || ""),
        content_type: "product",
        content_name: String(item.title || "")
      };
    });
    var contentIds = contents
      .map(function (item) {
        return item.id;
      })
      .filter(Boolean);
    var orderNameStr = String(orderName || "").trim();
    var legacyId = normalizeShopifyOrderId(shopifyOrderId);
    // Shopify Meta / Facebook CAPI: event_id = order id numérico (legacyResourceId).
    // Antes usábamos el nombre (#5258 → _5258) y no coincidía → 2× en Ads.
    var eventId = legacyId
      ? legacyId
      : orderNameStr
        ? String(orderNameStr).replace(/\W+/g, "_")
        : "cz_ic_" + Date.now() + "_" + Math.random().toString(36).slice(2, 8);
    return {
      orderName: orderNameStr || "",
      order_id: legacyId || orderNameStr || "",
      shopify_order_id: legacyId || "",
      currency: currency,
      value: value,
      paymentMethod: method,
      content_ids: contentIds,
      contents: contents,
      content_type: "product",
      num_items: contents.reduce(function (sum, item) {
        return sum + Number(item.quantity || 1);
      }, 0),
      event_id: eventId
    };
  };

  /** legacyResourceId numérico, o id de GID gid://shopify/Order/123 → "123". */
  function normalizeShopifyOrderId(value) {
    if (value == null) {
      return "";
    }
    var raw = String(value).trim();
    if (!raw) {
      return "";
    }
    var gidMatch = raw.match(/gid:\/\/shopify\/Order\/(\d+)/i);
    if (gidMatch) {
      return gidMatch[1];
    }
    if (/^\d+$/.test(raw)) {
      return raw;
    }
    return "";
  }

  /** InitiateCheckout / AddPaymentInfo — solo landings, vía fbq. Nunca Purchase (CAPI Shopify). */
  PackCodCheckout.prototype.trackMetaExpressEvent = function (eventName, paymentMethod, orderId) {
    if (!this.isMetaLandingContext()) {
      return;
    }
    var name = String(eventName || "").trim();
    // Purchase solo vía canal Meta/CAPI de Shopify (pedido Admin), no fbq del theme.
    if (name.toLowerCase() === "purchase") {
      return;
    }
    var payload = this.buildMetaExpressPayload(paymentMethod, orderId || "");
    fireMetaBrowserEvent(name, payload, payload.event_id);
  };

  function detectInstalledAdPixels() {
    if (detectInstalledAdPixels.cache) {
      return detectInstalledAdPixels.cache;
    }
    var blob = "";
    try {
      var scripts = document.querySelectorAll("script:not([src])");
      for (var i = 0; i < scripts.length; i += 1) {
        var text = scripts[i].textContent || "";
        if (
          text.indexOf("webPixelsConfigList") !== -1 ||
          text.indexOf("pixelCode") !== -1 ||
          text.indexOf("pixel_id") !== -1
        ) {
          blob += text;
        }
      }
    } catch (error) {
      blob = "";
    }

    var tiktokMatch =
      blob.match(/\\"pixelCode\\":\\"([A-Z0-9]{10,})\\"/) ||
      blob.match(/"pixelCode"\s*:\s*"([A-Z0-9]{10,})"/);
    var metaMatch =
      blob.match(/\\"pixel_id\\":\\"(\d{10,})\\"/) ||
      blob.match(/"pixel_id"\s*:\s*"(\d{10,})"/) ||
      blob.match(/fbq\s*\(\s*['"]init['"]\s*,\s*['"](\d{10,})['"]/);

    detectInstalledAdPixels.cache = {
      tiktokPixelId: tiktokMatch ? tiktokMatch[1] : null,
      metaPixelId: metaMatch ? metaMatch[1] : null
    };
    return detectInstalledAdPixels.cache;
  }

  function fireMetaBrowserEvent(eventName, payload, eventId) {
    try {
      if (typeof global.fbq !== "function") {
        return;
      }
      var name = String(eventName || "").trim();
      if (!name) {
        return;
      }
      var data = {
        value: payload.value,
        currency: payload.currency,
        content_ids: payload.content_ids,
        contents: payload.contents,
        content_type: "product",
        num_items: payload.num_items
      };
      if (payload.order_id) {
        data.order_id = payload.order_id;
      }
      var options = eventId ? { eventID: String(eventId) } : undefined;
      if (options) {
        global.fbq("track", name, data, options);
      } else {
        global.fbq("track", name, data);
      }
    } catch (error) {
      console.warn("Meta fbq track failed:", name, error);
    }
  }

  function ensureTikTokTtq(pixelId) {
    return new Promise(function (resolve) {
      if (global.ttq && typeof global.ttq.track === "function") {
        resolve(global.ttq);
        return;
      }
      if (!pixelId) {
        resolve(null);
        return;
      }
      if (global.__czTikTokPixelLoading) {
        global.__czTikTokPixelLoading.then(resolve);
        return;
      }
      global.__czTikTokPixelLoading = new Promise(function (innerResolve) {
        var w = global;
        var d = document;
        var t = "ttq";
        w.TiktokAnalyticsObject = t;
        var ttq = (w[t] = w[t] || []);
        ttq.methods = [
          "page",
          "track",
          "identify",
          "instances",
          "debug",
          "on",
          "off",
          "once",
          "ready",
          "alias",
          "group",
          "enableCookie",
          "disableCookie"
        ];
        ttq.setAndDefer = function (obj, method) {
          obj[method] = function () {
            obj.push([method].concat(Array.prototype.slice.call(arguments, 0)));
          };
        };
        for (var i = 0; i < ttq.methods.length; i += 1) {
          ttq.setAndDefer(ttq, ttq.methods[i]);
        }
        ttq.instance = function (id) {
          var inst = ttq._i[id] || [];
          for (var n = 0; n < ttq.methods.length; n += 1) {
            ttq.setAndDefer(inst, ttq.methods[n]);
          }
          return inst;
        };
        ttq.load = function (id) {
          var url = "https://analytics.tiktok.com/i18n/pixel/events.js";
          ttq._i = ttq._i || {};
          ttq._i[id] = [];
          ttq._i[id]._u = url;
          ttq._t = ttq._t || {};
          ttq._t[id] = +new Date();
          ttq._o = ttq._o || {};
          var script = d.createElement("script");
          script.type = "text/javascript";
          script.async = true;
          script.src = url + "?sdkid=" + id + "&lib=" + t;
          script.onload = function () {
            innerResolve(w.ttq || ttq);
          };
          script.onerror = function () {
            innerResolve(null);
          };
          var first = d.getElementsByTagName("script")[0];
          if (first && first.parentNode) {
            first.parentNode.insertBefore(script, first);
          } else {
            d.head.appendChild(script);
          }
        };
        try {
          ttq.load(pixelId);
          if (typeof ttq.page === "function") {
            ttq.page();
          }
        } catch (error) {
          console.warn("TikTok pixel load failed:", error);
          innerResolve(null);
        }
        // Fallback si onload no dispara (cola lista de inmediato).
        setTimeout(function () {
          innerResolve(w.ttq || ttq);
        }, 1200);
      });
      global.__czTikTokPixelLoading.then(resolve);
    });
  }

  function fireTikTokPurchase(pixelId, payload) {
    ensureTikTokTtq(pixelId).then(function (ttq) {
      if (!ttq || typeof ttq.track !== "function") {
        return;
      }
      try {
        ttq.track(
          "CompletePayment",
          {
            value: payload.value,
            currency: payload.currency,
            contents: payload.contents,
            content_type: "product",
            order_id: payload.order_id
          },
          { event_id: payload.event_id }
        );
      } catch (error) {
        console.warn("TikTok CompletePayment track failed:", error);
      }
    });
  }

  PackCodCheckout.prototype.getShopDomain = function () {
    return (
      (global.Shopify && global.Shopify.shop) ||
      this.config.shopDomain ||
      "caletzza.myshopify.com"
    );
  };

  PackCodCheckout.prototype.getLandingInvoiceDiscount = function () {
    var kind = String(this.config.packKind || this.config.packLabel || "")
      .toLowerCase()
      .replace(/á/g, "a")
      .replace(/é/g, "e")
      .replace(/í/g, "i");
    if (kind.indexOf("basic") !== -1) {
      return 6010000;
    }
    if (kind.indexOf("body") !== -1) {
      return 2010000;
    }
    var packDiscount = this.pendingSummary ? Number(this.pendingSummary.discountTotal || 0) : 0;
    var shipping = this.pendingSummary ? Number(this.pendingSummary.shipping || 0) : 0;
    return Math.max(0, packDiscount - shipping);
  };

  PackCodCheckout.prototype.rulesForInvoice = function () {
    var invoiceDiscount = this.getLandingInvoiceDiscount();
    var original = this.pendingSummary ? Number(this.pendingSummary.originalSubtotal || 0) : 0;
    var items = this.pendingLineItems || [];
    var qty = items.reduce(function (sum, item) {
      return sum + Number(item.quantity || 1);
    }, 0);
    var targetSubtotal = Math.max(0, original - invoiceDiscount);
    var unit = qty > 0 ? Math.round(targetSubtotal / qty) : 0;
    var productIds = items
      .map(function (item) {
        return item.productId;
      })
      .filter(Boolean);
    var prefixes = [];
    items.forEach(function (item) {
      var first = String(item.title || "")
        .trim()
        .split(/\s+/)[0];
      if (first && prefixes.indexOf(first) === -1) {
        prefixes.push(first);
      }
    });

    if (unit > 0 && (productIds.length || prefixes.length)) {
      return [
        {
          id: "landing-invoice-freight",
          title: "Pack landing",
          enabled: true,
          scope: "both",
          exclusive: true,
          priority: 100,
          count_mode: "filter_set",
          filter: {
            type: "collection",
            product_ids: productIds,
            title_prefixes: prefixes
          },
          ranges: [{ min: 1, max: 0, type: "fixed_price_per_item", value: unit, label: "" }]
        }
      ];
    }

    return this.readDiscountRules().map(function (rule) {
      var copy = Object.assign({}, rule);
      if (String(copy.scope || "pack").toLowerCase() === "pack") {
        copy.scope = "both";
      }
      return copy;
    });
  };

  PackCodCheckout.prototype.confirmShippingNotice = function () {
    var api = window.CzCheckoutShippingNotice;
    if (api && typeof api.show === "function") {
      return api.show("landing");
    }
    return Promise.resolve(true);
  };

  PackCodCheckout.prototype.markLandingDraftCheckout = function () {
    try {
      global.__czAllowMetaPurchase = true;
      if (global.sessionStorage) {
        global.sessionStorage.setItem("cz_landing_draft_checkout", "1");
      }
    } catch (error) {
      /* ignore */
    }
  };

  PackCodCheckout.prototype.submitOnline = function (customer) {
    var self = this;
    this.markLandingDraftCheckout();
    this.trackMetaExpressEvent("AddPaymentInfo", "online");
    var email = checkoutEmail(customer);
    var shop = this.getShopDomain();
    var lineItems = this.pendingLineItems.map(function (item) {
      return {
        id: item.variantId,
        variant_id: item.variantId,
        variantId: item.variantId,
        product_id: item.productId,
        quantity: item.quantity || 1,
        title: item.title,
        unit_price: item.originalUnitPrice || item.unitPrice
      };
    });
    var payload = {
      shop: shop,
      email: email,
      phone: customer.phone,
      taxExempt: true,
      includePackRules: true,
      invoiceCheckout: true,
      action: "discounted_checkout",
      mode: "draft_invoice",
      paymentMethod: "online",
      checkoutSource: "landing",
      packLabel: this.config.packLabel || "Pack Bodys",
      note: [this.config.packLabel, "Pago en linea", customer.note].filter(Boolean).join(" | "),
      shippingPrice: 0,
      discountAmount: this.getLandingInvoiceDiscount(),
      customer: {
        firstName: customer.names.firstName,
        lastName: customer.names.lastName,
        phone: customer.phone,
        email: email
      },
      shippingAddress: {
        firstName: customer.names.firstName,
        lastName: customer.names.lastName,
        address1: customer.address1,
        city: customer.city,
        province: customer.province,
        country: "Colombia",
        zip: "000000"
      },
      items: lineItems,
      lineItems: lineItems,
      rules: this.rulesForInvoice()
    };

    var checkoutUrls = [
      "https://cod-express-r15e.onrender.com/checkout?shop=" + encodeURIComponent(shop),
      "/apps/cod-express/checkout"
    ];

    function postCheckout(url) {
      return fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json"
        },
        credentials: /^https?:\/\//i.test(url) ? "omit" : "same-origin",
        body: JSON.stringify(payload)
      }).then(parseOrderResponse);
    }

    function raceCheckout() {
      return new Promise(function (resolve, reject) {
        var pending = checkoutUrls.length;
        var settled = false;
        checkoutUrls.forEach(function (url) {
          postCheckout(url).then(
            function (data) {
              if (settled) {
                return;
              }
              if (data && data.invoiceUrl) {
                settled = true;
                resolve(data);
                return;
              }
              pending -= 1;
              if (pending === 0) {
                reject(new Error("No se obtuvo invoiceUrl."));
              }
            },
            function () {
              if (settled) {
                return;
              }
              pending -= 1;
              if (pending === 0) {
                reject(new Error("No se obtuvo invoiceUrl."));
              }
            }
          );
        });
      });
    }

    // Preparar invoice mientras el usuario lee el aviso.
    var invoicePromise = raceCheckout();

    this.confirmShippingNotice().then(function (ok) {
      if (!ok) {
        self.setLoading(false);
        return;
      }
      var api = window.CzCheckoutShippingNotice;
      if (api && typeof api.setBusy === "function") {
        api.setBusy(true, "Aguarda, estamos aplicando los descuentos para alistar tu pedido...");
      }
      return invoicePromise
        .then(function (data) {
          window.location.href = data.invoiceUrl;
        })
        .catch(function (error) {
          console.warn("Invoice checkout failed:", error);
          if (api && typeof api.close === "function") {
            api.close();
          }
          self.setLoading(false);
          self.showError(
            "No se pudo abrir el pago en linea con el precio del pack. Intenta de nuevo o usa contra entrega."
          );
        });
    });
  };

  PackCodCheckout.prototype.submitOnlineFallback = function (customer) {
    var self = this;

    fetch("/cart/clear.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json"
      }
    })
      .catch(function () {
        return null;
      })
      .then(function () {
        return fetch(cartAddUrl(self.config.cartUrl), {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json"
          },
          body: JSON.stringify({ items: self.pendingItems })
        });
      })
      .then(function (response) {
        if (!response.ok) {
          throw new Error("No se pudo agregar el pack al carrito.");
        }
        return fetch("/cart/update.js", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json"
          },
          body: JSON.stringify({
            note: self.buildCartNote(customer),
            attributes: self.buildCartAttributes(customer)
          })
        });
      })
      .then(function (response) {
        if (!response.ok) {
          throw new Error("No se pudo preparar el checkout.");
        }
        window.location.href = self.config.checkoutUrl || "/checkout";
      })
      .catch(function (error) {
        self.showError(
          error.message +
            ". Si el problema continua, usa el checkout alternativo o contacta a la tienda."
        );
      })
      .finally(function () {
        self.setLoading(false);
      });
  };

  PackCodCheckout.prototype.submitMercadoPago = function (customer) {
    // Modo theme "mercadopago" → checkout ePayco (keys solo en Render).
    var self = this;
    this.pendingCustomer = customer;
    this.setLoading(true);
    this.loadEpaycoSdk()
      .then(function () {
        return self.mountEpaycoCheckout(customer);
      })
      .then(function (result) {
        if (result === "online_fallback") {
          return;
        }
        self.setLoading(false);
      })
      .catch(function (error) {
        console.warn("ePayco checkout failed:", error);
        self.setLoading(false);
        self.showError(
          (error && error.message) ||
            "No se pudo iniciar ePayco. Revisa EPAYCO_PUBLIC_KEY y las demas keys en Render."
        );
      });
  };

  PackCodCheckout.prototype.loadEpaycoSdk = function () {
    if (global.ePayco && global.ePayco.checkout) {
      return Promise.resolve(global.ePayco);
    }
    return new Promise(function (resolve, reject) {
      var existing = document.querySelector('script[data-epayco-sdk="checkout"]');
      if (existing) {
        existing.addEventListener("load", function () {
          if (global.ePayco && global.ePayco.checkout) {
            resolve(global.ePayco);
          } else {
            reject(new Error("SDK ePayco cargado sin checkout."));
          }
        });
        existing.addEventListener("error", function () {
          reject(new Error("No se pudo cargar el SDK de ePayco."));
        });
        return;
      }
      var script = document.createElement("script");
      script.src = "https://checkout.epayco.co/checkout.js";
      script.async = true;
      script.setAttribute("data-epayco-sdk", "checkout");
      script.onload = function () {
        if (global.ePayco && global.ePayco.checkout) {
          resolve(global.ePayco);
        } else {
          reject(new Error("SDK ePayco cargado sin checkout."));
        }
      };
      script.onerror = function () {
        reject(new Error("No se pudo cargar el SDK de ePayco."));
      };
      document.head.appendChild(script);
    });
  };

  function resolveClientPublicIp() {
    if (global.__czClientIp) {
      return Promise.resolve(global.__czClientIp);
    }
    function fetchIp(url, parse) {
      return fetch(url, { credentials: "omit", cache: "no-store" })
        .then(function (response) {
          if (!response.ok) {
            throw new Error("ip lookup failed");
          }
          return parse(response);
        })
        .then(function (ip) {
          ip = String(ip || "").trim();
          if (!ip || ip.indexOf(".") === -1) {
            throw new Error("invalid ip");
          }
          global.__czClientIp = ip;
          return ip;
        });
    }
    return fetchIp("https://api.ipify.org?format=json", function (response) {
      return response.json().then(function (data) {
        return data && data.ip;
      });
    })
      .catch(function () {
        return fetchIp("https://api64.ipify.org?format=json", function (response) {
          return response.json().then(function (data) {
            return data && data.ip;
          });
        });
      })
      .catch(function () {
        return "";
      });
  }

  PackCodCheckout.prototype.loadMercadoPagoSdk = function () {
    if (global.MercadoPago) {
      return Promise.resolve(global.MercadoPago);
    }
    return new Promise(function (resolve, reject) {
      var existing = document.querySelector('script[data-mp-sdk="v2"]');
      if (existing) {
        existing.addEventListener("load", function () {
          resolve(global.MercadoPago);
        });
        existing.addEventListener("error", function () {
          reject(new Error("No se pudo cargar el SDK de Mercado Pago."));
        });
        return;
      }
      var script = document.createElement("script");
      script.src = "https://sdk.mercadopago.com/js/v2";
      script.async = true;
      script.setAttribute("data-mp-sdk", "v2");
      script.onload = function () {
        resolve(global.MercadoPago);
      };
      script.onerror = function () {
        reject(new Error("No se pudo cargar el SDK de Mercado Pago."));
      };
      document.head.appendChild(script);
    });
  };

  PackCodCheckout.prototype.getPackDiscountAmount = function () {
    if (!this.pendingSummary) {
      return 0;
    }
    var explicit = Number(this.pendingSummary.discountTotal || 0);
    if (explicit > 0) {
      return explicit;
    }
    // Respaldo si showNetSubtotal oculta la fila pero hay gap list vs neto.
    var original = Number(this.pendingSummary.originalSubtotal || 0);
    var subtotal = Number(this.pendingSummary.subtotal || 0);
    return Math.max(0, original - subtotal);
  };

  PackCodCheckout.prototype.buildOrderPayload = function (customer, paymentMethod) {
    var discountAmount = this.getPackDiscountAmount();
    return {
      // Campos de descuento primero: el app proxy a veces trunca bodies grandes.
      packLabel: this.config.packLabel || "Pack Bodys",
      includePackRules: true,
      discountAmount: discountAmount,
      discountTotal: discountAmount,
      shippingPrice: this.pendingSummary ? this.pendingSummary.shipping : 0,
      paymentMethod: paymentMethod || "cod",
      currency: this.config.currency || "COP",
      totalCents: this.pendingSummary ? this.pendingSummary.total : 0,
      customer: {
        firstName: customer.names.firstName,
        lastName: customer.names.lastName,
        phone: customer.phone,
        email: customer.email || checkoutEmail(customer)
      },
      shippingAddress: {
        address1: customer.address1,
        city: customer.city,
        province: customer.province,
        country: "Colombia",
        zip: ""
      },
      lineItems: this.pendingLineItems.map(function (item) {
        return {
          variantId: item.variantId,
          product_id: item.productId,
          quantity: item.quantity || 1,
          title: item.title,
          unit_price: item.originalUnitPrice || item.unitPrice
        };
      }),
      // Sin rules enormes: el server carga metafield + pack (como invoice del migrado).
      note: customer.note
    };
  };

  PackCodCheckout.prototype.proxyUrls = function (suffix) {
    var base = this.config.orderEndpoint || "/apps/cod-express";
    var path = String(suffix || "").replace(/^\//, "");
    var urls = [
      base,
      "/apps/cod-express-1",
      "/apps/cod-express-1/order",
      "/apps/cod-express/order",
      "https://cod-express-r15e.onrender.com" + (path ? "/" + path : "/order")
    ];
    if (path && base.indexOf("http") !== 0) {
      urls.unshift(base.replace(/\/$/, "") + "/" + path);
    }
    return urls;
  };

  PackCodCheckout.prototype.postExpressAction = function (action, payload) {
    var body = Object.assign({}, payload, { action: action });
    var urls;
    // Config/confirm NUNCA deben ir a /order: esa ruta crea el pedido COD.
    if (action === "epayco_config") {
      urls = [
        "https://cod-express-r15e.onrender.com/epayco-config",
        "/apps/cod-express-1/epayco-config",
        "/apps/cod-express/epayco-config"
      ];
    } else if (action === "epayco_confirm") {
      urls = [
        "https://cod-express-r15e.onrender.com/epayco-confirm",
        "/apps/cod-express-1/epayco-confirm",
        "/apps/cod-express/epayco-confirm"
      ];
    } else if (action === "mercadopago_config") {
      urls = [
        "https://cod-express-r15e.onrender.com/mercadopago-config",
        "/apps/cod-express-1/mercadopago-config",
        "/apps/cod-express/mercadopago-config"
      ];
    } else if (action === "mercadopago_pay") {
      urls = [
        "https://cod-express-r15e.onrender.com/mercadopago-pay",
        "/apps/cod-express-1/mercadopago-pay",
        "/apps/cod-express/mercadopago-pay"
      ];
    } else if (action === "mercadopago_confirm") {
      urls = [
        "https://cod-express-r15e.onrender.com/mercadopago-confirm",
        "/apps/cod-express-1/mercadopago-confirm",
        "/apps/cod-express/mercadopago-confirm"
      ];
    } else {
      urls = this.proxyUrls("order");
    }
    return postOrderWithFallback(urls, body);
  };

  PackCodCheckout.prototype.applyMercadoPagoWalletCopy = function (root) {
    var scope = root || this.mpBrickWrap || this.mpBrickMount;
    if (!scope) {
      return;
    }
    var subtitle = "paga por PSE, tarjeta débito, crédito y más";
    var walker = document.createTreeWalker(scope, NodeFilter.SHOW_TEXT, null);
    var node;
    while ((node = walker.nextNode())) {
      var raw = String(node.nodeValue || "");
      var trimmed = raw.trim();
      if (!trimmed) {
        continue;
      }
      var lower = trimmed.toLowerCase();
      if (
        lower.indexOf("medios de pago favoritos") !== -1 ||
        lower.indexOf("tus medios de pago") !== -1
      ) {
        node.nodeValue = raw.replace(trimmed, subtitle);
        continue;
      }
      if (
        lower === "mercado wallet" ||
        lower === "mercado pago wallet" ||
        lower === "cuenta de mercado pago" ||
        lower === "wallet de mercado pago"
      ) {
        node.nodeValue = raw.replace(trimmed, "Mercado Pago");
      }
    }
  };

  PackCodCheckout.prototype.startMercadoPagoWalletCopyWatcher = function () {
    var self = this;
    var scope = this.mpBrickWrap || this.mpBrickMount;
    if (!scope || typeof MutationObserver === "undefined") {
      this.applyMercadoPagoWalletCopy(scope);
      return;
    }
    if (this.mpWalletCopyObserver) {
      try {
        this.mpWalletCopyObserver.disconnect();
      } catch (error) {
        /* ignore */
      }
    }
    this.applyMercadoPagoWalletCopy(scope);
    this.mpWalletCopyObserver = new MutationObserver(function () {
      self.applyMercadoPagoWalletCopy(scope);
    });
    this.mpWalletCopyObserver.observe(scope, {
      childList: true,
      subtree: true,
      characterData: true
    });
  };

  PackCodCheckout.prototype.saveMercadoPagoPendingCheckout = function (payload) {
    try {
      if (!global.sessionStorage) {
        return;
      }
      global.sessionStorage.setItem(
        "cz_mp_pending_checkout",
        JSON.stringify(
          Object.assign({}, payload || {}, {
            savedAt: Date.now()
          })
        )
      );
    } catch (error) {
      console.warn("No se pudo guardar checkout MP en sessionStorage", error);
    }
  };

  PackCodCheckout.prototype.readMercadoPagoPendingCheckout = function () {
    try {
      if (!global.sessionStorage) {
        return null;
      }
      var raw = global.sessionStorage.getItem("cz_mp_pending_checkout");
      if (!raw) {
        return null;
      }
      var parsed = JSON.parse(raw);
      if (!parsed || typeof parsed !== "object") {
        return null;
      }
      return parsed;
    } catch (error) {
      return null;
    }
  };

  PackCodCheckout.prototype.clearMercadoPagoPendingCheckout = function () {
    try {
      if (global.sessionStorage) {
        global.sessionStorage.removeItem("cz_mp_pending_checkout");
      }
    } catch (error) {
      /* ignore */
    }
  };

  PackCodCheckout.prototype.maybeConfirmMercadoPagoReturn = function () {
    var self = this;
    try {
      var params = new URLSearchParams(global.location.search || "");
      var mpFlag = String(params.get("mp") || "").toLowerCase();
      var mpStatus = String(params.get("mp_status") || params.get("status") || "").toLowerCase();
      var paymentId = String(
        params.get("payment_id") || params.get("collection_id") || params.get("paymentId") || ""
      ).trim();
      if (!paymentId) {
        return;
      }
      if (mpFlag !== "return" && mpStatus !== "success" && mpStatus !== "approved" && mpStatus !== "pending") {
        return;
      }
      if (mpStatus === "failure" || mpStatus === "rejected") {
        this.showError("El pago con Mercado Pago no se completo. Intenta de nuevo.");
        return;
      }

      var pending = this.readMercadoPagoPendingCheckout() || {};
      var confirmPayload = {
        shop: this.getShopDomain(),
        paymentId: paymentId,
        action: "mercadopago_confirm",
        externalReference: pending.externalReference || ""
      };
      if (pending.order) {
        confirmPayload.order = pending.order;
        confirmPayload.lineItems = pending.order.lineItems || pending.lineItems || [];
        confirmPayload.customer = pending.order.customer || pending.customer;
        confirmPayload.shippingAddress =
          pending.order.shippingAddress || pending.shippingAddress;
        confirmPayload.packLabel = pending.order.packLabel || pending.packLabel;
        confirmPayload.shippingPrice = pending.order.shippingPrice || pending.shippingPrice;
        confirmPayload.discountAmount = pending.order.discountAmount || pending.discountAmount;
        confirmPayload.draftOrderId = pending.draftOrderId || "";
      }

      this.postExpressAction("mercadopago_confirm", confirmPayload)
        .then(function (data) {
          if (data && data.orderName) {
            self.clearMercadoPagoPendingCheckout();
            if (self.root) {
              self.root.hidden = false;
            }
            if (self.dialog && typeof self.dialog.showModal === "function" && !self.dialog.open) {
              try {
                self.dialog.showModal();
              } catch (error) {
                /* ignore */
              }
            }
            self.showSuccess(data.orderName, {
              paymentMethod: "mercadopago",
              orderId: data.orderId
            });
            return;
          }
          if (data && (data.mpStatus === "pending" || data.status === "pending")) {
            self.showError(
              "Tu pago sigue pendiente en Mercado Pago. Cuando se acredite confirmamos el pedido."
            );
          }
        })
        .catch(function (error) {
          console.warn("MP return confirm failed", error);
          self.showError(
            (error && error.message) ||
              "Pago recibido, pero no se pudo crear el pedido en Shopify. Escribe a la tienda con el ID " +
                paymentId
          );
        });
    } catch (error) {
      console.warn("MP return parse failed", error);
    }
  };

  PackCodCheckout.prototype.enrichPseFormData = function (formData, orderPayload, clientIp, callbackUrl) {
    var payFormData = Object.assign({}, formData || {});
    var method = String(payFormData.payment_method_id || payFormData.payment_type_id || "").toLowerCase();
    var isPse = method === "pse" || method === "bank_transfer";
    var customer = (orderPayload && orderPayload.customer) || {};
    var shipping = (orderPayload && orderPayload.shippingAddress) || {};
    var additional =
      payFormData.additional_info && typeof payFormData.additional_info === "object"
        ? Object.assign({}, payFormData.additional_info)
        : {};

    if (clientIp) {
      additional.ip_address = clientIp;
    } else if (!additional.ip_address || additional.ip_address === "null") {
      delete additional.ip_address;
    }
    if (Object.keys(additional).length) {
      payFormData.additional_info = additional;
    }

    payFormData.callback_url =
      callbackUrl ||
      (global.location && global.location.origin + global.location.pathname + "?mp=return") ||
      "https://caletzza.com.co/?mp=return";
    // /health responde 200; /mp-webhook 404 en Render y puede romper BankTransfers.
    payFormData.notification_url =
      payFormData.notification_url || "https://cod-express-r15e.onrender.com/health";

    if (!isPse) {
      return payFormData;
    }

    payFormData.payment_method_id = "pse";
    var institution =
      (payFormData.transaction_details && payFormData.transaction_details.financial_institution) ||
      payFormData.financial_institution ||
      "";
    if (!String(institution || "").trim()) {
      throw new Error(
        "Mercado Pago PSE requiere elegir el banco. Selecciona el banco en el formulario e intenta de nuevo."
      );
    }
    payFormData.transaction_details = { financial_institution: String(institution).trim() };

    var formPayer = payFormData.payer && typeof payFormData.payer === "object" ? payFormData.payer : {};
    var firstName =
      String(formPayer.first_name || customer.firstName || "").trim() ||
      String(customer.fullName || "")
        .trim()
        .split(/\s+/)[0] ||
      "Cliente";
    var lastName =
      String(formPayer.last_name || customer.lastName || "").trim() ||
      String(customer.fullName || "")
        .trim()
        .split(/\s+/)
        .slice(1)
        .join(" ") ||
      "Caletzza";
    var phoneDigits = String(
      customer.phone || (formPayer.phone && formPayer.phone.number) || ""
    ).replace(/\D/g, "");
    if (phoneDigits.indexOf("57") === 0 && phoneDigits.length >= 12) {
      phoneDigits = phoneDigits.slice(2);
    }
    var street = String(shipping.address1 || "").trim() || "Calle 1";
    var streetNumberMatch = street.match(/(\d{1,5})/);
    var streetName =
      street
        .replace(/\d+/g, " ")
        .replace(/[#.,/\-]+/g, " ")
        .replace(/\s+/g, " ")
        .trim()
        .slice(0, 18) || "Calle";
    var identification =
      formPayer.identification && typeof formPayer.identification === "object"
        ? {
            type: String(formPayer.identification.type || "CC").trim() || "CC",
            number: String(formPayer.identification.number || "")
              .replace(/\W/g, "")
              .slice(0, 15)
          }
        : null;
    if (!identification || !identification.number) {
      throw new Error(
        "Mercado Pago PSE requiere documento de identidad. Completa el documento en el formulario de pago."
      );
    }

    var payerEmail = String(formPayer.email || customer.email || "").trim();
    if (!payerEmail || payerEmail.indexOf("checkout.caletzza.local") !== -1) {
      payerEmail = "cliente+" + String(customer.phone || Date.now()).replace(/\D/g, "") + "@gmail.com";
    }

    payFormData.payer = {
      email: payerEmail,
      entity_type:
        String(formPayer.entity_type || "individual").toLowerCase() === "association"
          ? "association"
          : "individual",
      first_name: firstName.slice(0, 32),
      last_name: lastName.slice(0, 32),
      identification: identification,
      address: {
        zip_code: "11001",
        street_name: streetName,
        street_number: String(streetNumberMatch ? streetNumberMatch[1] : "1").slice(0, 5),
        neighborhood: String((orderPayload && orderPayload.note) || "Centro")
          .trim()
          .slice(0, 18) || "Centro",
        city: String(shipping.city || "Bogota").trim().slice(0, 18) || "Bogota",
        federal_unit: String(shipping.province || "CUN").trim().slice(0, 18) || "CUN"
      },
      phone: {
        area_code: (phoneDigits.slice(0, 3) || "300").padEnd(3, "0").slice(0, 3),
        number: (phoneDigits.slice(3) || phoneDigits || "0000000").slice(0, 10)
      }
    };

    // Objeto limpio: evita nulls del Brick que disparan "BankTransfers Api fail".
    return {
      transaction_amount: payFormData.transaction_amount,
      description: payFormData.description || (orderPayload && orderPayload.packLabel) || "Pedido Caletzza",
      payment_method_id: "pse",
      callback_url: payFormData.callback_url,
      notification_url: payFormData.notification_url,
      additional_info: { ip_address: clientIp },
      transaction_details: payFormData.transaction_details,
      payer: payFormData.payer
    };
  };

  PackCodCheckout.prototype.resolveMercadoPagoConfig = function (orderPayload) {
    var self = this;
    var localKey = String(this.config.mpPublicKey || "").trim();
    var loc = global.location || {};
    var returnUrl =
      loc.origin && loc.pathname
        ? String(loc.origin) + String(loc.pathname)
        : String(loc.href || "").split("?")[0].split("#")[0];
    var payload = {
      shop: this.getShopDomain(),
      action: "mercadopago_config",
      currency: this.config.currency || "COP",
      totalCents: this.pendingSummary ? Number(this.pendingSummary.total || 0) : 0,
      configOnly: true,
      returnUrl: returnUrl,
      callbackUrl: returnUrl
    };
    if (orderPayload && orderPayload.lineItems && orderPayload.lineItems.length) {
      payload.lineItems = orderPayload.lineItems;
      payload.order = orderPayload;
      payload.customer = orderPayload.customer;
      payload.shippingAddress = orderPayload.shippingAddress;
      payload.packLabel = orderPayload.packLabel;
      payload.shippingPrice = orderPayload.shippingPrice;
      payload.discountAmount = orderPayload.discountAmount;
      payload.note = orderPayload.note;
    }

    return this.postExpressAction("mercadopago_config", payload)
      .then(function (config) {
        config = config || {};
        if (localKey && !config.publicKey) {
          config.publicKey = localKey;
        }
        if (config.externalReference) {
          self.mpExternalReference = String(config.externalReference);
        }
        return config;
      })
      .catch(function () {
        if (localKey) {
          return { publicKey: localKey };
        }
        return null;
      });
  };

  PackCodCheckout.prototype.hideMercadoPagoBrick = function (options) {
    var keepFormHidden = options && options.keepFormHidden;
    if (this.mpBrickController && typeof this.mpBrickController.unmount === "function") {
      try {
        this.mpBrickController.unmount();
      } catch (error) {
        // ignore
      }
    }
    this.mpBrickController = null;
    if (this.mpBrickMount) {
      this.mpBrickMount.innerHTML = "";
    }
    if (this.mpBrickWrap) {
      this.mpBrickWrap.hidden = true;
    }
    if (keepFormHidden) {
      return;
    }
    if (this.fieldsNode) {
      this.fieldsNode.hidden = false;
    }
    if (this.paymentsFieldset) {
      this.paymentsFieldset.hidden = false;
    }
    if (this.submitButton) {
      this.submitButton.hidden = false;
    }
    this.updatePaymentUI();
  };

  PackCodCheckout.prototype.goToPseBankTransfer = function (paymentId) {
    var id = String(paymentId || "").trim();
    if (!id) {
      return;
    }
    window.location.href =
      "https://www.mercadopago.com.co/payments/" + encodeURIComponent(id) + "/bank_transfer";
  };

  PackCodCheckout.prototype.showMercadoPagoStatusScreen = function (paymentId) {
    var self = this;
    var id = String(paymentId || "").trim();
    if (!id) {
      return Promise.reject(new Error("Falta el ID de pago de Mercado Pago."));
    }
    if (!this.mpBrickWrap) {
      this.goToPseBankTransfer(id);
      return Promise.resolve(null);
    }
    if (!global.MercadoPago) {
      this.goToPseBankTransfer(id);
      return Promise.resolve(null);
    }

    var publicKey = String(this.mpPublicKey || this.config.mpPublicKey || "").trim();
    if (!publicKey) {
      this.goToPseBankTransfer(id);
      return Promise.resolve(null);
    }

    this.hideError();
    if (this.fieldsNode) {
      this.fieldsNode.hidden = true;
    }
    if (this.paymentsFieldset) {
      this.paymentsFieldset.hidden = true;
    }
    if (this.submitButton) {
      this.submitButton.hidden = true;
    }
    this.mpBrickWrap.hidden = false;

    // Destruir Payment Brick ANTES de montar Status Screen (instancias separadas).
    if (this.mpBrickController && typeof this.mpBrickController.unmount === "function") {
      try {
        this.mpBrickController.unmount();
      } catch (error) {
        // ignore
      }
    }
    this.mpBrickController = null;

    // Contenedor fresco: evita choque con el Payment Brick.
    var statusId = "pack-cod-mp-status-" + String((this.section && this.section.id) || "pack").replace(/\W/g, "");
    this.mpBrickWrap.innerHTML =
      '<div id="' +
      statusId +
      '" class="pack-cod__mp-status" data-cod-mp-status-mount></div>';
    this.mpBrickMount = this.mpBrickWrap.querySelector("[data-cod-mp-status-mount]");

    var mp = new global.MercadoPago(publicKey, { locale: "es-CO" });
    var bricksBuilder = mp.bricks();
    this.mpSdk = mp;
    this.mpBricksBuilder = bricksBuilder;

    var settings = {
      initialization: {
        paymentId: id
      },
      callbacks: {
        onReady: function () {},
        onError: function (error) {
          console.warn("MP Status Screen error", error);
          self.goToPseBankTransfer(id);
        }
      },
      customization: {
        visual: {
          hideStatusDetails: false,
          hideTransactionDate: true
        }
      }
    };

    return bricksBuilder
      .create("statusScreen", statusId, settings)
      .then(function (controller) {
        self.mpBrickController = controller;
        return controller;
      })
      .catch(function (error) {
        console.warn("MP Status Screen create failed", error);
        self.goToPseBankTransfer(id);
        return null;
      });
  };

  PackCodCheckout.prototype.resolveEpaycoConfig = function (orderPayload) {
    var self = this;
    var loc = global.location || {};
    var returnUrl =
      loc.origin && loc.pathname
        ? String(loc.origin) + String(loc.pathname)
        : String(loc.href || "").split("?")[0].split("#")[0];
    var payload = {
      shop: this.getShopDomain(),
      action: "epayco_config",
      currency: this.config.currency || "COP",
      totalCents: this.pendingSummary ? Number(this.pendingSummary.total || 0) : 0,
      epaycoConfigOnly: true,
      returnUrl: returnUrl,
      callbackUrl: returnUrl
    };
    if (orderPayload && orderPayload.lineItems && orderPayload.lineItems.length) {
      payload.lineItems = orderPayload.lineItems;
      payload.order = orderPayload;
      payload.customer = orderPayload.customer;
      payload.shippingAddress = orderPayload.shippingAddress;
      payload.packLabel = orderPayload.packLabel;
      payload.shippingPrice = orderPayload.shippingPrice;
      payload.discountAmount = orderPayload.discountAmount;
      payload.note = orderPayload.note;
    }

    return this.postExpressAction("epayco_config", payload)
      .then(function (config) {
        config = config || {};
        if (config.externalReference || config.invoice) {
          self.mpExternalReference = String(config.externalReference || config.invoice);
        }
        return config;
      })
      .catch(function (error) {
        console.warn("ePayco config failed", error);
        return null;
      });
  };

  PackCodCheckout.prototype.setEpaycoOverlayOpen = function (isOpen) {
    try {
      document.body.classList.toggle("pack-cod-epayco-open", Boolean(isOpen));
    } catch (error) {
      /* ignore */
    }
    // v1 (#oKvf3=99999) y v2 (.OnePageV2 overlay=9999) quedan bajo el express (1e6).
    if (isOpen) {
      var bump = function () {
        var ids = [
          "oKvf3",
          "fb4xtw",
          "checkout-epayco",
          "epayco-onepage-v2-container",
          "epayco-checkout-v2-iframe",
          "epayco-mobile-loader-container"
        ];
        ids.forEach(function (id) {
          var el = document.getElementById(id);
          if (el) {
            el.style.setProperty("z-index", "2147483000", "important");
            el.style.setProperty("position", "fixed", "important");
          }
        });
        var overlays = document.querySelectorAll(
          "[class*='OnePageV2-module_overlay'], [class*='OnePageV2-module_container']"
        );
        overlays.forEach(function (el) {
          el.style.setProperty("z-index", "2147483000", "important");
        });
      };
      bump();
      setTimeout(bump, 50);
      setTimeout(bump, 300);
      setTimeout(bump, 800);
      setTimeout(bump, 1600);
      if (!this._epaycoDomWatcher && typeof MutationObserver !== "undefined") {
        var self = this;
        this._epaycoDomWatcher = new MutationObserver(function () {
          if (document.body.classList.contains("pack-cod-epayco-open")) {
            bump();
          }
        });
        this._epaycoDomWatcher.observe(document.body, { childList: true, subtree: true });
      }
    } else if (this._epaycoDomWatcher) {
      try {
        this._epaycoDomWatcher.disconnect();
      } catch (error) {
        /* ignore */
      }
      this._epaycoDomWatcher = null;
    }
  };

  PackCodCheckout.prototype.openEpaycoCheckout = function (config, orderPayload) {
    var self = this;
    if (!global.ePayco || !global.ePayco.checkout) {
      throw new Error("SDK ePayco no disponible.");
    }
    var publicKey = String((config && config.publicKey) || "").trim();
    if (!publicKey) {
      throw new Error("Falta la public key de ePayco.");
    }
    var billing = (config && config.billing) || {};
    var handler = global.ePayco.checkout.configure({
      key: publicKey,
      test: Boolean(config && config.test)
    });
    var openData = {
      name: String((config && config.name) || orderPayload.packLabel || "Pack Caletzza"),
      description: String((config && config.description) || orderPayload.packLabel || "Pack Caletzza"),
      invoice: String((config && (config.invoice || config.externalReference)) || ""),
      currency: String((config && config.currency) || "COP"),
      amount: String((config && config.amount) || ""),
      country: "CO",
      lang: "es",
      external: "false",
      confirmation: String((config && config.confirmation) || "https://cod-express-r15e.onrender.com/epayco-webhook"),
      response: String((config && config.response) || ""),
      email_billing: billing.email || (orderPayload.customer && orderPayload.customer.email) || "",
      name_billing: billing.name || "",
      address_billing: billing.address || "",
      type_doc_billing: billing.typeDoc || "CC",
      mobilephone_billing: billing.mobile || "",
      number_doc_billing: billing.numberDoc || "",
      extra1: this.getShopDomain() || ""
    };

    this.setEpaycoOverlayOpen(true);
    handler.onCloseModal = function () {
      self.setEpaycoOverlayOpen(false);
    };
    try {
      global.addEventListener(
        "message",
        function onEpaycoMsg(event) {
          var data = event && event.data;
          if (!data || typeof data !== "object") {
            return;
          }
          if (data.event === "onCloseModal" || data.event === "handleCloseModal") {
            self.setEpaycoOverlayOpen(false);
            global.removeEventListener("message", onEpaycoMsg);
          }
        },
        false
      );
    } catch (error) {
      /* ignore */
    }

    handler.open(openData);
  };

  PackCodCheckout.prototype.mountEpaycoCheckout = function (customer) {
    var self = this;
    if (!this.mpBrickMount || !this.mpBrickWrap) {
      return Promise.reject(new Error("No hay contenedor para ePayco."));
    }

    var totalCents = this.pendingSummary ? Number(this.pendingSummary.total || 0) : 0;
    if (totalCents <= 0) {
      return Promise.reject(new Error("Total invalido para cobro."));
    }
    // paymentMethod epayco en el payload; el mode del theme sigue siendo mercadopago.
    var orderPayload = this.buildOrderPayload(customer, "epayco");

    return this.resolveEpaycoConfig(orderPayload).then(function (config) {
      var publicKey = config && config.publicKey ? String(config.publicKey).trim() : "";
      if (!publicKey || !config.invoice) {
        // Sin keys en Render → invoice Shopify (no volver a Mercado Pago).
        self.submitOnline(customer);
        return "online_fallback";
      }
      if (!global.ePayco || !global.ePayco.checkout) {
        throw new Error("SDK de ePayco no disponible.");
      }

      self.hideError();
      if (self.fieldsNode) {
        self.fieldsNode.hidden = true;
      }
      if (self.paymentsFieldset) {
        self.paymentsFieldset.hidden = true;
      }
      if (self.submitButton) {
        self.submitButton.hidden = true;
      }
      self.mpBrickWrap.hidden = false;
      self.mpBrickMount.innerHTML = "";

      self.mpPublicKey = publicKey;
      self.mpExternalReference = String(config.externalReference || config.invoice || "");
      self.saveMercadoPagoPendingCheckout({
        provider: "epayco",
        externalReference: self.mpExternalReference,
        draftOrderId: config.draftOrderId || "",
        invoice: config.invoice || "",
        order: orderPayload,
        lineItems: orderPayload.lineItems,
        customer: orderPayload.customer,
        shippingAddress: orderPayload.shippingAddress,
        packLabel: orderPayload.packLabel,
        shippingPrice: orderPayload.shippingPrice,
        discountAmount: orderPayload.discountAmount
      });

      self.mpBrickMount.innerHTML =
        '<div class="pack-cod__mp-guest">' +
        '<p class="pack-cod__mp-hint">Con una sola cuenta, puedes pagar con dinero disponible, guardar tus tarjetas favoritas y más.</p>' +
        '<ul class="pack-cod__mp-methods" aria-label="Medios de pago">' +
        '<li class="pack-cod__mp-method" title="PSE">' +
        '<span class="pack-cod__mp-badge pack-cod__mp-badge--pse" aria-hidden="true">' +
        '<svg viewBox="0 0 48 28" width="40" height="22"><rect width="48" height="28" rx="4" fill="#fff"/><circle cx="15" cy="14" r="8" fill="#0B2C6B"/><text x="15" y="17.5" text-anchor="middle" fill="#fff" font-size="7" font-family="Arial,sans-serif" font-weight="700">pse</text><circle cx="33" cy="14" r="6" fill="#F5A623"/><circle cx="33" cy="14" r="3" fill="#fff"/></svg>' +
        "</span></li>" +
        '<li class="pack-cod__mp-method" title="Visa">' +
        '<span class="pack-cod__mp-badge pack-cod__mp-badge--visa" aria-hidden="true">' +
        '<svg viewBox="0 0 48 28" width="40" height="22"><rect width="48" height="28" rx="4" fill="#fff"/><text x="24" y="18" text-anchor="middle" fill="#1A1F71" font-size="11" font-family="Arial Black,Arial,sans-serif" font-style="italic" font-weight="700">VISA</text></svg>' +
        "</span></li>" +
        '<li class="pack-cod__mp-method" title="Mastercard">' +
        '<span class="pack-cod__mp-badge pack-cod__mp-badge--mc" aria-hidden="true">' +
        '<svg viewBox="0 0 48 28" width="40" height="22"><rect width="48" height="28" rx="4" fill="#fff"/><circle cx="20" cy="14" r="7" fill="#EB001B"/><circle cx="28" cy="14" r="7" fill="#F79E1B"/><path d="M24 8.5a7 7 0 0 1 0 11 7 7 0 0 1 0-11z" fill="#FF5F00"/></svg>' +
        "</span></li>" +
        '<li class="pack-cod__mp-method" title="Daviplata">' +
        '<span class="pack-cod__mp-badge pack-cod__mp-badge--davi" aria-hidden="true">' +
        '<svg viewBox="0 0 48 28" width="40" height="22"><rect width="48" height="28" rx="4" fill="#fff"/><circle cx="24" cy="14" r="9" fill="#111"/><text x="24" y="18" text-anchor="middle" fill="#fff" font-size="12" font-family="Arial,sans-serif" font-weight="700">$</text></svg>' +
        "</span></li>" +
        '<li class="pack-cod__mp-method" title="American Express">' +
        '<span class="pack-cod__mp-badge pack-cod__mp-badge--amex" aria-hidden="true">' +
        '<svg viewBox="0 0 48 28" width="40" height="22"><rect width="48" height="28" rx="4" fill="#fff"/><rect x="10" y="6" width="28" height="16" rx="3" fill="#2E77BC"/><text x="24" y="17" text-anchor="middle" fill="#fff" font-size="7" font-family="Arial,sans-serif" font-weight="700">AM EX</text></svg>' +
        "</span></li>" +
        '<li class="pack-cod__mp-method" title="Codensa">' +
        '<span class="pack-cod__mp-badge pack-cod__mp-badge--codensa" aria-hidden="true">' +
        '<svg viewBox="0 0 48 28" width="40" height="22"><rect width="48" height="28" rx="4" fill="#fff"/><rect x="10" y="7" width="28" height="14" rx="2" fill="#F7C948"/><text x="14" y="13" fill="#111" font-size="4.5" font-family="Arial,sans-serif" font-weight="700">CODENSA</text><rect x="14" y="15" width="12" height="3" rx="1" fill="#111"/></svg>' +
        "</span></li>" +
        "</ul>" +
        '<button type="button" class="pack-cod__submit pack-cod__mp-guest-pay" data-cod-epayco-pay>Pagar</button>' +
        "</div>";

      var payBtn = self.mpBrickMount.querySelector("[data-cod-epayco-pay]");
      if (payBtn) {
        payBtn.addEventListener("click", function () {
          // AddPaymentInfo ya se disparó al continuar desde el formulario.
          self.setLoading(true);
          self.saveMercadoPagoPendingCheckout({
            provider: "epayco",
            externalReference: self.mpExternalReference,
            draftOrderId: config.draftOrderId || "",
            invoice: config.invoice || "",
            order: orderPayload,
            lineItems: orderPayload.lineItems,
            customer: orderPayload.customer,
            shippingAddress: orderPayload.shippingAddress,
            packLabel: orderPayload.packLabel,
            shippingPrice: orderPayload.shippingPrice,
            discountAmount: orderPayload.discountAmount
          });
          try {
            self.openEpaycoCheckout(config, orderPayload);
            self.setLoading(false);
          } catch (error) {
            self.setLoading(false);
            self.showError((error && error.message) || "No se pudo abrir ePayco.");
          }
        });
      }
      return "epayco_checkout";
    });
  };

  // Alias: el modo theme sigue llamando mountMercadoPagoBrick.
  PackCodCheckout.prototype.mountMercadoPagoBrick = function (customer) {
    return this.mountEpaycoCheckout(customer);
  };

  PackCodCheckout.prototype.maybeConfirmEpaycoReturn = function () {
    var self = this;
    try {
      var params = new URLSearchParams(global.location.search || "");
      var epFlag = String(params.get("epayco") || "").toLowerCase();
      var refPayco = String(params.get("ref_payco") || params.get("refPayco") || "").trim();
      if (!refPayco && epFlag !== "return") {
        return;
      }
      if (!refPayco) {
        return;
      }

      var pending = this.readMercadoPagoPendingCheckout() || {};
      var confirmPayload = {
        shop: this.getShopDomain(),
        ref_payco: refPayco,
        action: "epayco_confirm",
        externalReference: pending.externalReference || pending.invoice || ""
      };
      if (pending.order) {
        confirmPayload.order = pending.order;
        confirmPayload.lineItems = pending.order.lineItems || pending.lineItems || [];
        confirmPayload.customer = pending.order.customer || pending.customer;
        confirmPayload.shippingAddress =
          pending.order.shippingAddress || pending.shippingAddress;
        confirmPayload.packLabel = pending.order.packLabel || pending.packLabel;
        confirmPayload.shippingPrice = pending.order.shippingPrice || pending.shippingPrice;
        confirmPayload.discountAmount = pending.order.discountAmount || pending.discountAmount;
        confirmPayload.draftOrderId = pending.draftOrderId || "";
      }

      this.postExpressAction("epayco_confirm", confirmPayload)
        .then(function (data) {
          if (data && data.orderName) {
            self.clearMercadoPagoPendingCheckout();
            if (self.root) {
              self.root.hidden = false;
            }
            if (self.dialog && typeof self.dialog.showModal === "function" && !self.dialog.open) {
              try {
                self.dialog.showModal();
              } catch (error) {
                /* ignore */
              }
            }
            self.showSuccess(data.orderName, {
              paymentMethod: "epayco",
              orderId: data.orderId
            });
            return;
          }
          if (data && (data.status === "pending" || data.epaycoStatus === "Pendiente")) {
            self.showError(
              "Tu pago sigue pendiente en ePayco. Cuando se acredite confirmamos el pedido."
            );
          }
        })
        .catch(function (error) {
          console.warn("ePayco return confirm failed", error);
          self.showError(
            (error && error.message) ||
              "Pago recibido, pero no se pudo crear el pedido en Shopify. Escribe a la tienda con la ref " +
                refPayco
          );
        });
    } catch (error) {
      console.warn("ePayco return parse failed", error);
    }
  };

  PackCodCheckout.prototype.submitCod = function (customer) {
    var self = this;
    this.trackMetaExpressEvent("AddPaymentInfo", "cod");
    var payload = this.buildOrderPayload(customer, "cod");

    var orderUrls = [
      this.config.orderEndpoint || "/apps/cod-express",
      "/apps/cod-express-1",
      "/apps/cod-express-1/order",
      "/apps/cod-express/order"
    ];

    postOrderWithFallback(orderUrls, payload)
      .then(function (data) {
        self.showSuccess(data.orderName, {
          paymentMethod: "cod",
          orderId: data.orderId
        });
      })
      .catch(function (error) {
        self.showError(
          error.message +
            ". Si el problema continua, usa el checkout alternativo o contacta a la tienda."
        );
      })
      .finally(function () {
        self.setLoading(false);
      });
  };

  PackCodCheckout.prototype.submit = function () {
    if (!this.form || !this.pendingItems.length) {
      return;
    }

    if (!this.form.reportValidity()) {
      return;
    }

    var customer = this.readFormData();
    var paymentMethod = this.getPaymentMethod();

    this.setLoading(true);
    this.hideError();

    if (paymentMethod === "online") {
      this.submitOnline(customer);
      return;
    }

    if (paymentMethod === "mercadopago") {
      // Continuar al panel ePayco = AddPaymentInfo (el clic Pagar refuerza otro).
      this.trackMetaExpressEvent("AddPaymentInfo", "epayco");
      this.submitMercadoPago(customer);
      return;
    }

    this.submitCod(customer);
  };

  global.PackCodCheckout = {
    create: function (section, config) {
      return new PackCodCheckout(section, config);
    },
    formatMoney: formatMoney,
    findVariantDetails: findVariantDetails
  };
})(window);
